<div *mwcModalTitle>
  <div class="d-flex align-items-center">
    <div class="d-flex align-items-center gap-2">
      <span i18n="@@bs-select-your-keyword-heading-text" class="mwc-text-xl-medium mwc-color-gray-900">Select Keywords</span>
      <mwc-tag [mwcColor]="'primary'" class="mwc-text-xs-regular">{{getTotalKeywords()}}/{{getTotalAllowedKeywords()}} Selected</mwc-tag>
      <span class="mwc-color-gray-400" mwc-icon mwcIconfont="help-circle" style="display: inline-flex;align-items: center;margin-left:5px;font-size:14px" mwc-tooltip [mwcTooltipTitle]="maxSelectionTooltip" mwcTooltipColor="black" mwcTooltipPlacement="top"></span>
    </div>
  </div>
</div>

<ng-template #GKPToolTip let-tooltip>
  <span style="display: inline-flex;align-items: center;margin-left:5px">{{tooltip}}</span>
</ng-template>

<ng-template #maxSelectionTooltip>
  <span style="display: inline-flex;align-items: center;margin-left:5px">
    <ng-container *ngIf="!isFailsafe">You can select up to {{maxAllowedKeywordSelection}} trending keywords based on their organic search performance.</ng-container>
    <ng-container *ngIf="isFailsafe">No keyword data was available, so we generated these contextually. Select up to {{maxAllowedKeywordSelection}} to continue.</ng-container>
  </span>
</ng-template>
<div mwc-row [mwcGutter]="[0, 32]">
  <div mwc-col [mwcSpan]="24">
    <!-- Dynamic alert banner -->
    <mwc-alert
      [mwcType]="alertType"
      [mwcMessage]="alertMsgTemplate"
      [mwcIcon]="alertIconTemplate"
      mwcShowIcon="true"
      class="prompts-alert">
    </mwc-alert>

    <ng-template #alertIconTemplate>
      <span mwc-icon
            [mwcIconfont]="selectedCount >= maxAllowedKeywordSelection ? 'check-circle' : 'stars-02'"
            style="font-size: 16px;">
      </span>
    </ng-template>

    <ng-template #alertMsgTemplate>
      <span *ngIf="selectedCount >= maxAllowedKeywordSelection" class="mwc-text-sm-medium">
        Perfect! You've selected all {{ maxAllowedKeywordSelection }} keywords.
      </span>
      <span *ngIf="selectedCount === 0" class="mwc-text-sm-regular">
        Select <strong>{{ maxAllowedKeywordSelection }} keywords</strong> for best results
      </span>
      <span *ngIf="selectedCount > 0 && selectedCount < maxAllowedKeywordSelection" class="mwc-text-sm-regular">
        Select <strong>{{ remainingCount }} more keyword{{ remainingCount > 1 ? 's' : '' }}</strong> for best results
      </span>
    </ng-template>

    <mwc-table #rowSelectionTable [mwcPageSize] = "20" [mwcScroll]="{ y: 'calc(100vh - 325px)' }" [mwcShowPagination]="false" [mwcData]="listOfData" [mwcLoadingIndicator]="tableSpinTpl" mwcClassName="select-your-keyword-table-body overflow-auto" class="select-your-keyword-table" mwcTableLayout="fixed" [mwcWidthConfig]="['','180px','160px','150px']">
      <thead>
        <tr>
          <th i18n="@@bs-select-your-keyword-table-col-th-keyphrase-text" style="width: 40%;">Keywords
            <span class="mwc-color-gray-400" mwc-icon mwcIconfont="help-circle"
              style="display: inline-flex;align-items: center;margin-left:5px" mwc-tooltip
              [mwcTooltipTitle]="GKPToolTip" [mwcTooltipTitleContext]="{ $implicit: GKPToolTips.KEYPHRASE_TOOLTIP }"
              mwcTooltipColor="black" mwcTooltipPlacement="top"></span>
          </th>
          <th i18n="@@bs-select-your-keyword-table-col-th-search-vol-text" style="width: 22%;">Search Volume
            <span class="mwc-color-gray-400" mwc-icon mwcIconfont="help-circle"
              style="display: inline-flex;align-items: center;margin-left:5px" mwc-tooltip
              [mwcTooltipTitle]="GKPToolTip" [mwcTooltipTitleContext]="{ $implicit: GKPToolTips.SEARCH_VOLUME_TOOLTIP }"
              mwcTooltipColor="black" mwcTooltipPlacement="top"></span>
          </th>
          <th i18n="@@bs-select-your-keyword-table-col-th-trend-text" style="width: 18%;">Trend
            <span class="mwc-color-gray-400" mwc-icon mwcIconfont="help-circle"
              style="display: inline-flex;align-items: center;margin-left:5px" mwc-tooltip
              [mwcTooltipTitle]="GKPToolTip" [mwcTooltipTitleContext]="{ $implicit: GKPToolTips.TREND_TOOLTIP }"
              mwcTooltipColor="black" mwcTooltipPlacement="top"></span>
          </th>
          <th i18n="@@bs-select-your-keyword-table-col-th-competition-text" style="width: 20%;">Competition
            <span class="mwc-color-gray-400" mwc-icon mwcIconfont="help-circle"
              style="display: inline-flex;align-items: center;margin-left:5px" mwc-tooltip
              [mwcTooltipTitle]="GKPToolTip" [mwcTooltipTitleContext]="{ $implicit: GKPToolTips.COMPETITION_TOOLTIP }"
              mwcTooltipColor="black" mwcTooltipPlacement="top"></span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of rowSelectionTable.data">
          <td>
            <span>
              <mwc-checkbox-wrapper (mwcOnChange)="keywordSelectionChange(data,$event)">
                <label mwc-checkbox [mwcChecked]="existingKeyword.includes(data.keyPhrase)" [mwcValue]="data.keyPhrase" [mwcDisabled]="((selectedKeywords.length >= maxAllowedKeywordSelection) && (!selectedKeywords.includes(data)) || (existingKeyword.includes(data.keyPhrase)) )">
                  <span class="mwc-text-sm-medium mwc-color-gray-600" style="margin-left: 6px;">{{ data.keyPhrase }}</span>
                </label>
              </mwc-checkbox-wrapper>
            </span>
          </td>
          <td>
            <ng-container *ngIf="data.hasMetrics; else noSearchVolume">
              <span class="mwc-color-gray-600">{{ displayMetric(data.searchVolume) }}</span>
            </ng-container>
            <ng-template #noSearchVolume>
              <span class="not-available">{{ FailsafeKeyword.NOT_AVAILABLE }}</span>
            </ng-template>
          </td>
          <td>
            <ng-container *ngIf="data.hasMetrics; else noTrendUnavailable">
              <div class="line-graph" *ngIf="data.trend?.length; else noTrendValue"><g2-mini-area line borderColor="#12B76A" color="#ECFDF3" height="40"
                [data]="data.trend"></g2-mini-area></div>
            </ng-container>
            <ng-template #noTrendUnavailable><span class="not-available" style="padding-left: 10px;">{{ FailsafeKeyword.NOT_AVAILABLE }}</span></ng-template>
            <ng-template #noTrendValue><span class="mwc-color-gray-600">NA</span></ng-template>
          </td>
          <td>
            <ng-container *ngIf="data.hasMetrics; else noCompetitionUnavailable">
              <mwc-tag *ngIf="data.competition; else noCompetitionValue" [mwcColor]="'primary'">{{ data.competition }}</mwc-tag>
            </ng-container>
            <ng-template #noCompetitionUnavailable><span class="not-available" style="padding-left: 10px;">{{ FailsafeKeyword.NOT_AVAILABLE }}</span></ng-template>
            <ng-template #noCompetitionValue><span class="mwc-color-gray-600">NA</span></ng-template>
          </td>
        </tr>
      </tbody>
    </mwc-table>
  </div>
</div>

<ng-template #tableSpinTpl>
  <div style="display: flex; justify-content: center; align-items: center; width: 100%; min-height: 150px; height: 100%;">
    <img src="assets/images/ai-loader.gif" alt="Loading" style="width: 40px; height: 40px;">
  </div>
</ng-template>
<div *mwcModalFooter>
  <div mwc-row style="gap:16px; justify-content: flex-end;align-items: center;">
    <div mwc-col>
      <button mwc-button mwcSize="small" mwcType="default" mwcBlock (click)="cancelSelection()"
        [disabled]="(listOfData == null || listOfData == undefined || listOfData?.length == 0)"
        [mwcLoading]="isLoading">Cancel</button>
    </div>
    <div mwc-col>
      <button mwc-button mwcSize="small" mwcType="primary" mwcBlock (click)="addKeywords()"
        [disabled]="(listOfData == null || listOfData == undefined || listOfData?.length == 0)"
        [mwcLoading]="isLoading">Add Keywords</button>
    </div>
  </div>
</div>

